module.exports = __webpack_public_path__ + "static/media/view1.6dc92a00.jpg";